import { IEditCategoryRestaurantPropertiesState } from './editCategoryRestaurantPropertiesContext';
import {
	TEditCategoryRestaurantPropertiesAction,
	EditCategoryRestaurantPropertiesActionTypes,
} from './editCategoryRestaurantPropertiesActions';

export const editRestaurantPropertiesReducer = (
	state: IEditCategoryRestaurantPropertiesState,
	action: TEditCategoryRestaurantPropertiesAction,
): IEditCategoryRestaurantPropertiesState => {
	switch (action.type) {
		case EditCategoryRestaurantPropertiesActionTypes.REFETCH_RESTAURANT_PROPERTIES_DATA:
			return {
				...state,
				needRefetchRestaurantPropertiesData: action.payload.needRefetchRestaurantPropertiesData,
			};
		case EditCategoryRestaurantPropertiesActionTypes.SET_ALL_DATA:
			return {
				...state,
				categoryId: action.payload.categoryId,
				categoryName: action.payload.categoryName,
				customerName: action.payload.customerName,
				hasSchedulePriority: action.payload.hasSchedulePriority,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditCategoryRestaurantPropertiesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				subcategories: action.payload.subcategories,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditCategoryRestaurantPropertiesActionTypes.SET_SUBCATEGORIES:
			return {
				...state,
				subcategories: action.payload.subcategories,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditCategoryRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditCategoryRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditCategoryRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditCategoryRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
